import { 
  formatDateTime,
  formatHora,
  getTempoPercurso,
  m
} from '../dateUtils';
import { formatProgressValue } from '../table/tripTable';
import { 
  getVehiclePrefix,
  getDiferencaKmRota,
  getTipoEscala,
  MOTIVES, 
  VEHICLE_CHANGE_MOTIVES,
  getVehicleLabel 
} from '../tripUtils';

export function buildTripTableData({
  trip,
  tripStatus,
  pontos,
  positionsAnalysis,
  perfisDisponiveis,
  kmTotalRota,
  motorista,
  ultimaOcorrencia,
  ultimaTrocaVeic,
  turnoNome,
  tripExportType = false,
  forExcel = false
}) {

  const DATAHORA_FINAL_PREVISTO =
    tripStatus?.DATAHORA_FINAL_PREVISTO ??
    trip?.DATAHORA_FINAL_PREVISTO;

  const situacao =
    tripStatus?.situacao ??
    'Agendada';

  const detaTrip =
    tripStatus?.detaTrip ??
    '';

  const hrInicio =
    tripStatus?.hrInicio ??
    null;

  const hrFim =
    tripStatus?.hrFim ??
    null;

  const barColor =
    tripStatus?.barColor ??
    'primary';


  const progressoPontos = positionsAnalysis?.progressoPontos ?? 0;
  const progressoPercurso = positionsAnalysis?.progressoPercurso ?? 0;
  const totalP = pontos?.length ?? 0;
  const atendP = positionsAnalysis?.atendP ?? 0;
  const kmsRodados = positionsAnalysis?.kmsRodados ?? 0;
  
  const diferencaKm =
    getDiferencaKmRota(
      kmsRodados,
      kmTotalRota
    );

  const motivoOcorrencia =
    ultimaOcorrencia
        ? MOTIVES.find(
            item =>
                Number(item.id) ===
                Number(ultimaOcorrencia.motiveId)
        )
        : null;

  const ocorrenciaFormatada =
      ultimaOcorrencia
          ? [
              ultimaOcorrencia.createdAt
                  ? m(ultimaOcorrencia.createdAt)
                      .format('DD/MM/YYYY HH:mm')
                  : null,
              motivoOcorrencia?.label ??
                  `Motivo ${ultimaOcorrencia.motiveId}`
          ]
              .filter(Boolean)
              .join(' - ')
          : '';

  const motivoTrocaVeiculo =
    ultimaTrocaVeic
      ? VEHICLE_CHANGE_MOTIVES.find(
          item =>
            Number(item.id) ===
            Number(ultimaTrocaVeic.vehicleChangeMotive)
        )
      : null;

  const trocaVeiculoFormatada =
    ultimaTrocaVeic
      ? [
          getVehicleLabel(ultimaTrocaVeic.oldVehicle),
          getVehicleLabel(ultimaTrocaVeic.newVehicle)
        ].join(' → ')
      : '';

  const trocaPosterior =
    ultimaTrocaVeic?.createdAt &&
    trip?.DATAHORA_INICIAL_PREVISTO
      ? m(ultimaTrocaVeic.createdAt).isAfter(
          m(trip.DATAHORA_INICIAL_PREVISTO)
        )
      : false;

  const rowData = {

    Cliente: trip.GRUPO ?? '',

    'Código de Integração':
      trip.CODIGO_INTEGRACAO,

    Linha:
      `${trip.NOMELINHA} - ${trip.PREFIXO}`,

    Turno: turnoNome,

    Sentido:
      trip.SENTIDO === 0
        ? 'Entrada'
        : 'Retorno',

    'Unidade Operacional':
      perfisDisponiveis.find(
        p => p.id === trip.unidade_opera
      )?.nome ?? '',

    'Prefixo': getVehiclePrefix(trip?.license_plate),

    'Placa': trip?.license_plate,

    'OS': trip?.NUM_SERIE,

    'Tipo Escala': getTipoEscala(trip?.NUM_SERIE),

    'Troca de Veículo': trocaVeiculoFormatada,

    'Motivo da Troca':
      ultimaTrocaVeic
        ? motivoTrocaVeiculo?.label ??
          `Motivo ${ultimaTrocaVeic.vehicleChangeMotive}`
        : '',

    'Troca Posterior':
      ultimaTrocaVeic
        ? trocaPosterior ? 'Sim' : 'Não'
        : '',

    'Pontos Atendidos':
      formatProgressValue(
        `${atendP}/${totalP}`,
        progressoPontos,
        forExcel
      ),

    'Progresso':
      `${progressoPercurso}%`,

    'Motorista': motorista?.nome ?? 'Sem Motorista',

    'Matrícula': motorista?.matricula ?? ' - ',

    'Hora Pegada Prevista': formatHora(trip?.time_caught) || ' - ',

    'Início Previsto':
      formatDateTime(
        trip?.DATAHORA_INICIAL_PREVISTO,
        forExcel
      ),

    'Início Real':
      formatDateTime(
        hrInicio,
        forExcel
      ),

    'Final Previsto':
      formatDateTime(
        DATAHORA_FINAL_PREVISTO,
        forExcel
      ),

    'Final Real':
      formatDateTime(
        hrFim,
        forExcel
      ),

    'Tempo Previsto':
      getTempoPercurso(
        trip?.DATAHORA_INICIAL_PREVISTO,
        DATAHORA_FINAL_PREVISTO
      ) ?? '',

    'Tempo Real':
      getTempoPercurso(
        hrInicio,
        hrFim
      ) ?? '',

    'KM Previsto': kmTotalRota,

    'KM Real': kmsRodados,

    'Dif. KM': diferencaKm?.excel ?? '',

    Status:
      detaTrip
        ? `${situacao} - ${detaTrip}`
        : situacao,

    'Ocorrência': ocorrenciaFormatada,

    situacao,
    detalheSituacao:
      detaTrip,

    barColor
  };

  if (tripExportType === 'escala') {

    const escalaColumns = [
      'Cliente',
      'Código de Integração',
      'Linha',
      'Turno',
      'Sentido',
      'Prefixo',
      'Placa',
      'Motorista',
      'Matrícula',
      'Hora Pegada Prevista',
      'Início Previsto',
      'Final Previsto',
      'Tempo Previsto',
      'KM Previsto'
    ];

    return Object.fromEntries(
      escalaColumns.map(column => [
        column,
        rowData[column]
      ])
    );

  }

  return rowData;

}